import { Mail, Phone, Clock } from "lucide-react";
import PageHero from "@/components/PageHero";
import SectionHeading from "@/components/SectionHeading";
import EnquiryForm from "@/components/EnquiryForm";
import { FadeUp } from "@/components/Reveal";
import { IMAGES, OFFICES, CONTACT_INFO } from "@/data/content";
import SEO from "@/components/SEO";

const Contact = () => (
  <>
    <SEO
      title="Contact Us"
      description="Talk to Seed Park India — corporate office at Quthbullapur, Secunderabad, Telangana. Call +91 8008788449 or email team@seedpark.in."
    />
    <PageHero
      eyebrow="Contact Us"
      titleLines={["Let's talk seeds,", "science and scale."]}
      description="Product enquiries, distribution partnerships, research collaboration or careers — the Seed Park team responds within one working day."
      image={IMAGES.aerial}
    />

    <section data-testid="contact-main" className="py-28 lg:py-36">
      <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-7">
          <SectionHeading
            eyebrow="Our Locations"
            titleLines={["Headquartered in Hyderabad.", "Rooted across India."]}
          />
          <div className="grid gap-5 sm:grid-cols-3" data-testid="offices-grid">
            {OFFICES.map((o, i) => (
              <FadeUp key={o.label} delay={i * 0.08} className="h-full">
                <div className="flex h-full flex-col border border-white/10 bg-forest-900 p-7" data-testid={`office-card-${i}`}>
                  <span className="w-fit border border-brand-400/40 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-brand-400">{o.tag}</span>
                  <h3 className="mt-5 font-display text-lg font-bold tracking-tight">{o.label}</h3>
                  <div className="mt-3 space-y-1">
                    {o.lines.map((l, j) => (
                      <p key={j} className="text-sm leading-relaxed text-mist">{l}</p>
                    ))}
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>

          <FadeUp delay={0.15}>
            <div className="mt-10 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-3" data-testid="contact-channels">
              <a href={`mailto:${CONTACT_INFO.email}`} className="group bg-forest-950 p-7 transition-colors hover:bg-forest-900" data-testid="contact-email-card">
                <Mail className="h-5 w-5 text-brand-400" />
                <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-sage">Email</p>
                <p className="mt-1 text-sm font-semibold text-foreground group-hover:text-brand-400">{CONTACT_INFO.email}</p>
              </a>
              <a href={`tel:${CONTACT_INFO.phone}`} className="group bg-forest-950 p-7 transition-colors hover:bg-forest-900" data-testid="contact-phone-card">
                <Phone className="h-5 w-5 text-brand-400" />
                <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-sage">Phone</p>
                <p className="mt-1 text-sm font-semibold text-foreground group-hover:text-brand-400">{CONTACT_INFO.phone}</p>
              </a>
              <div className="bg-forest-950 p-7" data-testid="contact-hours-card">
                <Clock className="h-5 w-5 text-brand-400" />
                <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-sage">Working Hours</p>
                <p className="mt-1 text-sm font-semibold text-foreground">{CONTACT_INFO.hours}</p>
              </div>
            </div>
          </FadeUp>
        </div>

        <div className="lg:col-span-5">
          <FadeUp delay={0.1}>
            <div className="lg:sticky lg:top-28">
              <EnquiryForm type="general" heading="Send Us a Message" testId="contact-enquiry" />
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  </>
);

export default Contact;
